module.exports = __webpack_public_path__ + "static/media/belching-copy.0d54afbb.svg";